var _defs, _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_352_710",
    x1: 11.9453,
    y1: 2.98092,
    x2: 12.2763,
    y2: 24.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_352_710",
    x1: 15.5412,
    y1: 6.25174,
    x2: 8.50862,
    y2: 18.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_352_710",
    x1: 10.4105,
    y1: 8.77231,
    x2: 14.0469,
    y2: 16.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFCD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFBD5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_352_710",
    x1: 9.70188,
    y1: 12.3084,
    x2: 14.6569,
    y2: 12.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AE45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_352_710",
    x1: 12.2452,
    y1: 10.0811,
    x2: 12.2452,
    y2: 17.1659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFF3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_352_710",
    x1: 10.3288,
    y1: 12.2844,
    x2: 14.1616,
    y2: 12.2844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AE45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD171"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.589 10.932H20.5925V10.5268C20.5925 5.82532 16.782 2.01877 12.0845 2.01877C7.3869 2.01877 3.57288 5.82846 3.57288 10.5268V13.5107C3.57288 18.2122 7.38336 22.0188 12.0809 22.0188C16.7785 22.0188 20.589 18.2087 20.589 13.5107V10.932Z",
    fill: "url(#paint0_linear_352_710)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0489 10.5268C20.1582 6.05289 16.5588 2.56234 12.0845 2.42399C9.58161 2.34735 9.66532 3.53156 12.6709 6.18377C19.9176 12.5781 20.0234 11.6194 20.0485 10.5268H20.0489Z",
    fill: "#FFDD92"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9518 11.0149C16.9518 8.2971 14.875 5.9436 12.1572 5.9436C9.43933 5.9436 7.23872 8.14775 7.23872 10.862C7.23872 11.6017 7.26427 12.7856 7.27881 13.5253C7.32991 16.1739 9.49042 18.7243 12.2083 18.7243C14.9261 18.7243 17.0029 16.5202 17.0646 13.846C17.0827 13.1063 16.9518 11.7546 16.9518 11.0149Z",
    fill: "url(#paint1_linear_352_710)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08454 15.8572C8.8824 17.2709 10.3944 18.2217 12.1324 18.2217C14.6974 18.2217 16.7777 16.1413 16.7777 13.5764V10.8621C16.7777 10.2171 16.6429 9.60514 16.4059 9.04388C15.6336 7.54995 14.074 6.52649 12.2778 6.52649C9.71288 6.52649 7.63255 8.60683 7.63255 11.1718V13.8861C7.63255 14.7822 7.88763 15.6166 8.32468 16.3272C8.23743 16.1779 8.15725 16.021 8.08414 15.8572H8.08454ZM9.70188 11.1498C9.70188 9.77964 10.813 8.67207 12.1792 8.67207C13.5454 8.67207 14.6565 9.78318 14.6565 11.1498V13.4742C14.6565 14.8439 13.5454 15.9515 12.1792 15.9515C10.813 15.9515 9.70188 14.8404 9.70188 13.4742V11.1498Z",
    fill: "#BF6400"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6716 10.9167V13.5728C16.6716 16.1158 14.6022 18.1745 12.0518 18.1745C10.3248 18.1745 8.8203 17.2273 8.02597 15.8316C8.74012 17.4564 10.3649 18.5895 12.2594 18.5895C14.8098 18.5895 16.9156 16.3999 16.9156 13.857C16.9156 13.1649 16.8791 12.0207 16.8791 11.3286C16.8791 10.5087 16.7297 9.54344 16.4165 9.0769C16.6641 9.64523 16.6716 10.2611 16.6716 10.9167Z",
    fill: "#F9AA4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62154 13.8896V11.1753C7.62154 8.61038 9.70187 6.53004 12.2668 6.53004C14.0048 6.53004 15.564 7.53935 16.3619 8.95271C15.7935 7.30589 13.9573 6.06351 12.0554 6.06351C9.49042 6.06351 7.41362 8.19494 7.41362 10.7599V13.4742C7.41362 14.3011 7.63215 15.0809 8.01103 15.7514C7.75949 15.1796 7.62114 14.5491 7.62114 13.8896H7.62154Z",
    fill: "#EF9635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 11.1494C14.6604 9.77927 13.5493 8.67169 12.1831 8.67169C10.8169 8.67169 9.70541 9.7828 9.70541 11.1494V13.4738C9.70541 14.8435 10.8165 15.9511 12.1831 15.9511C13.5497 15.9511 14.6604 14.84 14.6604 13.4738V11.1494Z",
    fill: "url(#paint2_linear_352_710)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1796 8.8108C13.4695 8.8108 14.5185 9.8602 14.5185 11.1497V13.4742C14.5185 14.7641 13.4691 15.8131 12.1796 15.8131C10.89 15.8131 9.84062 14.7637 9.84062 13.4742V11.1497C9.84062 9.85981 10.89 8.8108 12.1796 8.8108ZM12.1796 8.66852C10.8098 8.66852 9.70227 9.77963 9.70227 11.1458V13.4702C9.70227 14.8404 10.8134 15.9475 12.1796 15.9475C13.5458 15.9475 14.6569 14.8364 14.6569 13.4702V11.1458C14.6604 9.77963 13.5493 8.66852 12.1796 8.66852Z",
    fill: "url(#paint3_linear_352_710)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1616 11.2445C14.1616 10.1841 13.3017 9.32803 12.2452 9.32803C11.1887 9.32803 10.3288 10.188 10.3288 11.2445V13.3248C10.3288 14.3848 11.1887 15.2413 12.2452 15.2413C13.3017 15.2413 14.1616 14.3813 14.1616 13.3248V11.2445Z",
    fill: "url(#paint4_linear_352_710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2452 9.46638C13.2254 9.46638 14.0233 10.2642 14.0233 11.2445V13.3248C14.0233 14.305 13.2254 15.1029 12.2452 15.1029C11.265 15.1029 10.4671 14.305 10.4671 13.3248V11.2445C10.4636 10.2642 11.2614 9.46638 12.2452 9.46638ZM12.2452 9.32803C11.1852 9.32803 10.3288 10.188 10.3288 11.2445V13.3248C10.3288 14.3848 11.1887 15.2413 12.2452 15.2413C13.3017 15.2413 14.1616 14.3813 14.1616 13.3248V11.2445C14.1616 10.1841 13.3017 9.32803 12.2452 9.32803Z",
    fill: "url(#paint5_linear_352_710)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M7.00132 14.2858L7.32086 13.9179C7.3189 13.7898 7.30278 13.4506 7.28824 13.0933L4.48904 16.1716L4.44817 16.2286C4.52324 16.4373 4.60459 16.6401 4.69381 16.8374C5.16663 16.3127 5.9928 15.3993 7.00093 14.2858H7.00132Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M16.5631 3.78036C16.4031 3.66284 16.2498 3.55318 16.0706 3.44824L13.6185 6.1594C13.7883 6.24705 14.0229 6.29146 14.2084 6.37714C14.9894 5.51561 15.7904 4.63246 16.5631 3.78036Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M7.7312 15.5714L5.41818 18.1151C6.02817 18.9767 6.84962 19.7635 7.71508 20.3417C8.13445 19.8759 8.88436 19.0466 9.81507 18.0184C8.84034 17.4391 8.14545 16.5367 7.7312 15.571V15.5714Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M17.6652 4.65408L15.3191 7.23436C15.3993 7.29724 15.4705 7.35384 15.4952 7.37899V7.38253C16.42 8.3101 16.716 9.0435 16.8524 10.2757C17.9855 9.0266 18.9469 7.96697 19.5313 7.32279C19.0907 6.30994 18.4532 5.40399 17.6652 4.65369V4.65408Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToken);
export default __webpack_public_path__ + "static/media/icon-token.8d5b92c9cbbe2caee2e76fbfd6261919.svg";
export { ForwardRef as ReactComponent };